import useFlag from './useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2025-06-17T19:18:18+0530.
 */
export function useWorkOrderSpecificTeamWorkflowTargetEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.WorkOrderSpecificTeamWorkflowTarget, false);

  return Boolean(isEnabled);
}
